import { gql } from 'apollo-boost'
import { ID } from '../id.type'

export interface ContactVariables {
  code: ID
  contact: {
    email: string
    firstName: string
    lastName: string
    note?: string
    phone: string
  }
}

export interface ContactData {
  success: boolean
}

export const CONTACT_MUTATION = gql`
  mutation send($code: ID!, $contact: ContactInput!) {
    success: contactForCode(code: $code, contact: $contact)
  }
`
